import { useState } from 'react';
import './Tooltip.css';

export default function Tooltip({ children, content }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span 
      className="tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      <button 
        type="button" 
        className="tooltip-trigger"
        aria-label="More information"
        tabIndex={0}
      >
        {children}
      </button>
      {isVisible && (
        <div className="tooltip-content" role="tooltip">
          {content}
          <div className="tooltip-arrow" />
        </div>
      )}
    </span>
  );
}
